
<mat-form-field class="fuse-mat-no-subscript w-full">
  <mat-label>Place of work</mat-label>
  <mat-icon
    class="icon-size-5"
    [svgIcon]="'heroicons_solid:search'"
    matPrefix></mat-icon>
  <input #searchField  matInput placeholder="Enter address" (blur)="mapCheck($event)">
</mat-form-field>
